import { CustomFieldForm } from 'components/field/form/CustomFieldForm';
import { classNames } from 'libs/react';
import { React, useEffect, useState } from 'libs/react';
import { FormGroup } from 'components/form/FormGroup';
import { FormField } from 'components/form/FormField';
import { FormDate } from 'components/form/FormDate';
import './DynamicSalesFormField.scss';
/**
 * @component FieldSection
 * @since 1.0.0
 */
export function FieldSection(props) {
    const { fieldGroups, hideGroupTitle, plannedDate, plannedDateMode } = props;
    const [formValues, setFormValues] = useState({});
    // Listen for postMessage events
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data.type === 'centralio-form-values' && event.data.values) {
                const values = event.data.values;
                const processedValues = {};
                // Process the values to extract field IDs and their values
                Object.keys(values).forEach((key) => {
                    if (key.startsWith('fields.')) {
                        const fieldId = key.replace('fields.', '');
                        processedValues[fieldId] = { value: values[key] };
                    }
                });
                setFormValues(processedValues);
            }
        };
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);
    const mergedValues = fieldGroups.map((group) => {
        return Object.assign(Object.assign({}, group), { fields: group.fields
                .filter((f) => f.visibility === 'DYNAMIC_SALES_FORM')
                .map((field) => {
                // Assign the value from postMessage if available
                const fieldValue = formValues[field.id];
                return Object.assign(Object.assign({}, field), { value: fieldValue ? JSON.stringify(fieldValue) : field.value, 
                    // Mark the required fields on their label
                    translations: field.required
                        ? field.translations.map((translation) => (Object.assign(Object.assign({}, translation), { title: `${translation.title} *` })))
                        : field.translations });
            }) });
    });
    if (mergedValues.filter((group) => group.fields.length > 0).length === 0) {
        return null;
    }
    const className = classNames('section field-section');
    return (React.createElement("div", { className: className },
        React.createElement("h2", null, t('Add information')),
        plannedDate && (React.createElement(React.Fragment, null,
            React.createElement(FormGroup, null,
                React.createElement(FormField, null,
                    React.createElement(FormDate, { name: "plannedDate", label: t('Desired date'), selectsRange: plannedDateMode === 'RANGE', time: false }))))),
        React.createElement(CustomFieldForm, { entity: "DEAL", fields: mergedValues, hideGroupTitle: hideGroupTitle, fromPublic: true, translable: false })));
}
